import {
  GET_UPCOMING_APPOINTMENT_LIST,
  GET_UPCOMING_APPOINTMENT_LIST_SUCCESS,
  GET_UPCOMING_APPOINTMENT_LIST_FAILURE,
} from 'store/getAppointment/getUpcomingAppointment/getUpcomingAppointmentAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getAppointmentUpcomigReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_UPCOMING_APPOINTMENT_LIST:
      return { ...state, loading: true };
    case GET_UPCOMING_APPOINTMENT_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_UPCOMING_APPOINTMENT_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getAppointmentUpcomigReducer;
